import { useSelfAssessmentWizard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.context'

export const useSelfAssessmentWizardQuestionProgress = () => {
  const { definition, questionIndex } = useSelfAssessmentWizard()

  return {
    questionNumber: questionIndex + 1,
    questionCount: definition.questions.length,
  }
}
